import {
  formatDateWithTime,
  gridSizeConst1,
  gridSizeConst10,
  gridSizeConst2,
  gridSizeMdLg12,
  gridSizeMdLg3,
  gridSizeMdLg5,
  gridSizeMdLg6,
  handleAxiosError,
  texto,
} from "@/shared";
import SearchIcon from "@mui/icons-material/Search";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomTextFieldNumberComponente,
  SampleCheckbox,
} from "@/shared/components/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import {
  CondicionVentaCorporativa,
  CondicionVentaCorporativaOptions,
//   IProspectoCorporativo,
  ISolicitudCanje,
  ISolicitudEvento,
  TipoSolicitudesEnum,
} from "@/shared/interfaces";
import { Grid, IconButton, Tooltip } from "@mui/material";
// import { UseFormReturn } from "react-hook-form";
import { Visibility } from "@mui/icons-material";
import ModalSolicitudCanje from "@/erp/marketing/revision-evento-canje/shared/ModalSolicitudesEventoCanje/ModalSolicitudCanje";
import ModalSolicitudEvento from "@/erp/marketing/revision-evento-canje/shared/ModalSolicitudesEventoCanje/ModalSolicitudEvento";
import { useState } from "react";
import { useUiStore } from "@/store/ui";
import { getSolicitudCanje } from "@/shared/actions/erp/marketing";
import { getSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";

interface CondicionVentaSelector {
  /**
   * Formulario que contenga obligatoriamente los campos:
   * - condicion_venta:string
   * - identificacion_canje_evento:string
   * - solicitud_canje:string
   * - solicitud_evento:string
   * - requiere_inspeccion:boolean
   * - requiere_cotizacion:boolean
   * - solicitud_canje_data:IsolicitudCanje
   * - solicitud_evento_data:IsolicitudEvento
   */
  form: any;
}

export default function CondicionVentaSelector({
  form,
}: CondicionVentaSelector) {
  // =========================================================================
  // states
  // =========================================================================
  const [openPreviewSolicitud, setOpenPreviewSolicitud] = useState<boolean>(false);
  const [dataCanje, setDataCanje] = useState<ISolicitudCanje[]>([]);
  const [dataEvento, setDataEvento] = useState<ISolicitudEvento[]>([]);
  // ===========================================================================
  // Stored functions
  // ===========================================================================
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);

  // =========================================================================
  // form
  // =========================================================================
  const {
    reset,
    control,
    formState: { errors },
  } = form;
  const watcherCondicionVenta = form.watch().condicion_venta;
  // =========================================================================
  // Handlers and functions
  // =========================================================================
  ///* buscar canje por cedula
  const handleBuscarCanje = async (identificacion: string) => {
    try {
      setIsGlobalLoading(true);
      const resp = await getSolicitudCanje({
        identificacion: identificacion,
      });

      const dataCanje: ISolicitudCanje[] = resp.data.data.map((e) => {
        return {
          ...e,
          razon_social: `${e.razon_social} - ${formatDateWithTime(
            e.fecha_creacion
          )}`,
        };
      });

      setDataCanje(dataCanje ?? []);
    } catch (error) {
      handleAxiosError(error);
    } finally {
      setIsGlobalLoading(false);
    }
  };

  const handleBuscarEvento = async (identificacion: string) => {
    try {
      setIsGlobalLoading(true);
      const resp = await getSolicitudEvento({
        identificacion: identificacion,
      });

      const dataEvento: ISolicitudEvento[] = resp.data.data.map((e) => {
        return {
          ...e,
          nombre: `${e.nombre} - ${formatDateWithTime(e.fecha_creacion)}`,
        };
      });

      setDataEvento(dataEvento ?? []);
    } catch (error) {
      handleAxiosError(error);
    } finally {
      setIsGlobalLoading(false);
    }
  };

  const handleBuscarSolicitudCanje = (aux: string) => {
    // Verifica la longitud de la cadena
    if (aux.length === 10 || aux.length === 13) {
      const { condicion_venta } = form.getValues()

      switch (condicion_venta) {
        case TipoSolicitudesEnum.CANJE:
          handleBuscarCanje(aux);
          break;
        case TipoSolicitudesEnum.EVENTO_GRATUITO:
        case TipoSolicitudesEnum.EVENTO_PAGADO:
          handleBuscarEvento(aux);
          break;
        default:
          break;
      }
      return;
    }

    // Si la longitud no es válida, se limpian los datos
    setDataCanje([]);
    setDataEvento([]);
  };

  const handleBuscarIconSolicitudCanje = (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();

    const { identificacion_canje_evento: identificacion, condicion_venta } =
      form.getValues();

    if (!identificacion) return;
    if (identificacion.length !== 10 && identificacion.length !== 13) return;

    switch (condicion_venta) {
      case TipoSolicitudesEnum.CANJE:
        handleBuscarCanje(identificacion);
        break;
      case TipoSolicitudesEnum.EVENTO_GRATUITO:
      case TipoSolicitudesEnum.EVENTO_PAGADO:
        handleBuscarEvento(identificacion);
        break;
      default:
        break;
    }
  };

  const handleLimpiarSolicitudCanjeEvento = () => {
    reset({
      ...form.getValues(),
      identificacion_canje_evento: "",
      solicitud_canje: "",
      solicitud_evento: "",
    });

    setDataCanje([]);
    setDataEvento([]);
  };

  return (
    <Grid container item spacing={2} {...gridSizeMdLg12}>
        <Grid container item spacing={2} {...gridSizeMdLg12}>
            <CustomAutocompleteArrString
            size={gridSizeMdLg6}
            label={"Condición Venta"}
            name="condicion_venta"
            options={CondicionVentaCorporativaOptions}
            defaultValue={form.getValues().condicion_venta || ""}
            isLoadingData={false}
            required={false}
            control={form.control}
            error={errors.condicion_venta}
            helperText={errors.condicion_venta?.message}
            onChangeValue={(val) => {
                handleLimpiarSolicitudCanjeEvento();

                if (val == null) {
                reset({
                    ...form.getValues(),
                    requiere_inspeccion: false,
                    requiere_cotizacion: false,
                });
                }
            }}
            />
            {watcherCondicionVenta ? (
            <>
                <SampleCheckbox
                size={gridSizeMdLg3}
                label="Requiere Inspección"
                control={form.control}
                name="requiere_inspeccion"
                defaultValue={!!form.getValues().requiere_inspeccion!}
                onChangeValue={(e) => {
                    form.reset({ ...form.getValues(), requiere_inspeccion: e });
                }}
                />
                <SampleCheckbox
                size={gridSizeMdLg3}
                label="Requiere Cotización"
                control={form.control}
                name="requiere_cotizacion"
                defaultValue={true}
                onChangeValue={(e) => {
                    form.reset({ ...form.getValues(), requiere_cotizacion: e });
                }}
                />
            </>
            ) : null}
        </Grid>

        {watcherCondicionVenta && watcherCondicionVenta!=CondicionVentaCorporativa.EVENTO_PAGADO && (
            <>
            <Grid
                container
                spacing={1}
                item
                xs={6}
                style={{
                justifyContent: "space-between",
                alignItems: "center",
                }}
            >
                <CustomTextFieldNumberComponente
                size={gridSizeConst10}
                max={13}
                type={TiposTextFieldNumberEnum.IDENTIFICACION}
                label={texto.identificacion_condicion_venta}
                error={errors.identificacion_canje_evento}
                helperText={errors.identificacion_canje_evento?.message}
                control={control}
                name="identificacion_canje_evento"
                defaultValue={form.getValues().identificacion_canje_evento || ""}
                onChangeValue={(aux) => {
                    handleBuscarSolicitudCanje(aux);
                }}
                />

                <Grid item {...gridSizeConst2}>
                <IconButton
                    onClick={(e: any) => {
                    handleBuscarIconSolicitudCanje(e);
                    }}
                    size="small"
                >
                    <SearchIcon />
                </IconButton>
                </Grid>
            </Grid>

            {form.getValues().condicion_venta == TipoSolicitudesEnum.CANJE && (
                <CustomAutocomplete<ISolicitudCanje>
                size={gridSizeMdLg5}
                label="Seleccionar Canje"
                name="solicitud_canje"
                options={
                    dataCanje?.filter((x) => x.canje_aplicado == false) || []
                }
                valueKey="razon_social"
                actualValueKey="codigo"
                defaultValue={undefined}
                isLoadingData={false}
                control={control}
                error={errors.solicitud_canje}
                onChangeRawValue={(rawValue) =>
                    reset({
                    ...form.getValues(),
                    solicitud_canje_data: rawValue,
                    identificacion: rawValue?.identificacion,
                    celular: rawValue?.numero_contacto,
                    direccion: rawValue?.direccion,
                    persona_contacto: rawValue?.nombre_contacto,
                    })
                }
                helperText={errors.solicitud_canje?.message}
                />
            )}

            {(form.getValues().condicion_venta ==
                TipoSolicitudesEnum.EVENTO_GRATUITO ||
                form.getValues().condicion_venta ==
                TipoSolicitudesEnum.EVENTO_PAGADO) && (
                <CustomAutocomplete<ISolicitudEvento>
                size={gridSizeMdLg5}
                label="Seleccionar Evento"
                name="solicitud_evento"
                options={
                    dataEvento?.filter((x) => x.evento_aplicado == false) || []
                }
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={undefined}
                isLoadingData={false}
                control={control}
                error={errors.solicitud_evento}
                onChangeRawValue={(rawValue) =>
                    reset({
                    ...form.getValues(),
                    solicitud_evento_data: rawValue,
                    identificacion: rawValue?.identificacion,
                    celular: rawValue?.numero_contacto,
                    persona_contacto: rawValue?.nombre_contacto,
                    })
                }
                helperText={errors.solicitud_evento?.message}
                />
            )}

            <Grid {...gridSizeConst1} item alignContent={"center"}>
                {!!form.getValues()?.solicitud_evento_data ||
                !!form.getValues()?.solicitud_canje_data ? (
                <Tooltip title="Vista previa de Solicitud">
                    <IconButton onClick={() => setOpenPreviewSolicitud(true)}>
                    <Visibility />
                    </IconButton>
                </Tooltip>
                ) : null}
            </Grid>

            {form.getValues()?.condicion_venta == TipoSolicitudesEnum.CANJE ? (
                <ModalSolicitudCanje
                showModal={openPreviewSolicitud}
                setShowModal={setOpenPreviewSolicitud}
                dataSelected={form.getValues()?.solicitud_canje_data!}
                />
            ) : null}
            {form.getValues()?.condicion_venta ==
                TipoSolicitudesEnum.EVENTO_GRATUITO ||
            form.getValues()?.condicion_venta ==
                TipoSolicitudesEnum.EVENTO_PAGADO ? (
                <ModalSolicitudEvento
                showModal={openPreviewSolicitud}
                setShowModal={setOpenPreviewSolicitud}
                dataSelected={form.getValues()?.solicitud_evento_data!}
                />
            ) : null}
            </>
        )}
    </Grid>
  );
}
